import {NgModule} from '@angular/core';
import {
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatTreeModule,
    MatTooltipModule, MatProgressBarModule, MatSnackBarModule
} from '@angular/material';
import {KeyValuePipe} from '@angular/common';

import {AgmCoreModule} from '@agm/core';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {FuseSharedModule} from '../@fuse/shared.module';

import {TruncatePipe} from './config/truncate-pipe';
import {StringifyPipe} from './config/stringify-pipe';
import {ApprovalPipe} from './config/approval-pipe';
import {BankAccountPipe} from './config/bank-account-pipe';
import {MonthPipe} from './config/month-pipe';
import {CompletePipe} from './config/complete-pipe';
import {BooleanPipe} from './config/boolean-pipe';
import {RemoveUnderscorePipe} from './config/remove-underscore-pipe';
import {SyncPipe} from './config/sync-pipe';
import {ForwardPipe} from './config/forward-pipe';
import {LockPipe} from './config/lock-pipe';
import {CurrencyConvertPipe} from './config/currency-convert-pipe';
import {RoundPipe} from './config/round-pipe';
import {DayDifferencePipe} from './config/day-difference.pipe';
import {AchievementPercentageCalculationPipe} from './config/achievement-percentage-calculation-pipe';
import {NgxDaterangepickerMd} from 'ngx-daterangepicker-material';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import {LeafletMarkerClusterModule} from '@asymmetrik/ngx-leaflet-markercluster';
import {AmountConversionPipe} from './config/amount-conversion-pipe';
import {DistancePipe} from './config/distance-pipe';


@NgModule({
    declarations: [TruncatePipe, StringifyPipe, ApprovalPipe, MonthPipe, BankAccountPipe,
        CompletePipe, BooleanPipe, RemoveUnderscorePipe, SyncPipe, ForwardPipe, LockPipe, CurrencyConvertPipe, RoundPipe, DayDifferencePipe,
        AchievementPercentageCalculationPipe, AmountConversionPipe, DistancePipe],
    imports: [
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatStepperModule,
        MatCheckboxModule,
        MatTreeModule,
        MatCardModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatExpansionModule,
        MatSlideToggleModule,
        MatDatepickerModule,
        MatDividerModule,
        MatGridListModule,
        MatButtonToggleModule,
        MatRadioModule,
        MatMenuModule,
        MatTooltipModule,
        MatProgressBarModule,
        MatSnackBarModule,

        AgmCoreModule,
        NgxMatSelectSearchModule,
        NgxDaterangepickerMd,
        FuseSharedModule,
        LeafletModule,
        LeafletMarkerClusterModule
    ],
    exports: [
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatStepperModule,
        MatCheckboxModule,
        MatTreeModule,
        MatCardModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatExpansionModule,
        MatSlideToggleModule,
        MatDatepickerModule,
        MatDividerModule,
        MatGridListModule,
        MatMenuModule,
        MatButtonToggleModule,
        MatRadioModule,
        MatTooltipModule,
        MatProgressBarModule,
        MatSnackBarModule,

        AgmCoreModule,
        NgxMatSelectSearchModule,
        NgxDaterangepickerMd,
        FuseSharedModule,
        LeafletModule,
        LeafletMarkerClusterModule,

        KeyValuePipe,
        TruncatePipe,
        StringifyPipe,
        ApprovalPipe,
        CompletePipe,
        RemoveUnderscorePipe,
        MonthPipe,
        BankAccountPipe,
        BooleanPipe,
        SyncPipe,
        ForwardPipe,
        LockPipe,
        CurrencyConvertPipe,
        RoundPipe,
        DayDifferencePipe,
        AchievementPercentageCalculationPipe,
        AmountConversionPipe,
        DistancePipe
    ],
    bootstrap: []
})
export class BizSharedModule {
}
